import backend from '@common/backend';
import normalizeMeets from '@common/helpers/normalizeMeets';

const BASE = '/meetSlots';

// export const getMeetSlots = (query: any) =>
// 	backend.get(`${BASE}`, {
// 		params: query,
// 	});

export const getMeetSlots = async (query: any) => {
	const response = await backend.get(`${BASE}`, {
		params: query,
	});

	const normalized = normalizeMeets(response);
	return normalized;
};

export const createMeetSlot = async (data: any) => backend.post(`${BASE}`, data);

export const createMeetSlotBulk = async (data: any[]) => backend.post(`${BASE}/bulk`, data);

export const removeMeetSlot = async (id: number) => backend.delete(`${BASE}/${id}`);
